import React, { useEffect, useState } from 'react'
import { MDBInput } from 'mdbreact';
import fotoVacia from '../../paginas/img/fotoVacia.jpg'

const AutoCompleta = ({registro, setRegistro, productos, urlProductos, tipo}) => {

  const [buscador, setBuscador] = useState('')
  const [activeCuadro, setActiveCuadro] = useState('hidden')

  // const [productos, setProductos] = useState([
  //   { nombre: 'Producto 1', id: 1, precio: 10000, image: 'https://districeleste.com/5587-large_default/esmalte-masglo-135-ml-novia.jpg'},
  //   { nombre: 'Cámara Inflaroja de uñas', id: 2, precio: 20000, image: 'https://districeleste.com/5587-large_default/esmalte-masglo-135-ml-novia.jpg'},
  //   { nombre: 'Corta', id: 3, precio: 3000, image: 'https://districeleste.com/5587-large_default/esmalte-masglo-135-ml-novia.jpg'},
  //   { nombre: 'Corta uñas', id: 4, precio: 3000, image: 'https://districeleste.com/5587-large_default/esmalte-masglo-135-ml-novia.jpg'}
  // ])

  const [productosFil, setProductosFil] = useState([])

  const RecibeBusqueda = e => {
    setBuscador(e.target.value)
    if (tipo === 'producto') {filtrar(e.target.value)}
    else{filtrarGeneral(e.target.value)}
    
  }

  const filtrar = (termino) => {
    let resultado = productos.filter((item) => {
      if (item.nombre_producto.toLowerCase().includes(termino.toLowerCase())) {
        return item
      }
    })
    setProductosFil(resultado)
  }

  const filtrarGeneral = (termino) => {
    let resultado = productos.filter((item) => {
      if (item.nombre.toLowerCase().includes(termino.toLowerCase())) {
        return item
      }
    })
    setProductosFil(resultado)
  }

  const SubeProducto = (producto) => {
    console.log('producto', producto)
    setBuscador('')
    if (tipo === 'producto') {setRegistro({...registro, producto: producto})}
    else{setRegistro(producto)}
    
  } 

  return (
    <div>
      <div className="form-group">
        <label>{tipo === 'producto' ? 'Producto a Promocinar' : `Selecciona ${tipo}`}:</label>
          <input 
              onChange={RecibeBusqueda} 
              value={buscador} 
              type="buscador" className="form-control" id="buscador" placeholder={`Buscar ${tipo}`}>
          </input>
        <div className={buscador.length > 0 ? `cuadroBusqueda` : `hidden`} >
          {tipo === 'producto' ?
            <div>
                  {productosFil.length > 0 ?
                      <div>
                            {productosFil.map(item => {
                              return (
                                <div key={item.id}>
                                  <button className='ProductMin' onClick={e => SubeProducto(item)}>
                                    <img className='fotoProdMin' src={urlProductos + item.url_imagen[0].nombre_imagen}></img>
                                    <div className='textProdMin'>
                                      <h6>{item.nombre_producto}</h6>
                                      <p>id:{item.id} - <b>{item.precio_rebajado > 0 ? item.precio_rebajado : item.precio_producto}</b></p>
                                    </div>

                                  </button>
                                  <hr></hr>
                                </div>
                              )
                            })}
                      </div>
                      :<p>{tipo} no encontrado...</p>
                  }
              </div>
            :
            <div>
                {productosFil.length > 0 ?
                      <div>
                            {productosFil.map(item => {
                              return (
                                <div key={item.id}>
                                  <button className='ProductMin' onClick={e => SubeProducto(item)}>
                                    <div className='textProdMin'>
                                      <h6>{item.nombre}</h6>
                                      <p>id:{item.id} - <b>{item.usuario}</b></p>
                                    </div>

                                  </button>
                                  <hr></hr>
                                </div>
                              )
                            })}
                      </div>
                      :<p>{tipo} no encontrado...</p>
                  }
            </div>

          }
          
        </div>
      </div>

    </div>
  )
}

export default AutoCompleta